<template>
  <div class="wrapper">
    <cube-scroll ref="scroll" class="cube-scroll">
      <div class="advwrap"></div>
      <div class="header">
        <i class="cubeic-back" @click="back"></i>
        订单信息
      </div>
      <div class="inner-wrapper">
        <div class="order-panel">
          <div class="order-record">
            <div class="park-name">{{ parkrec.parkName }}</div>
            <div class="plate">
              <span>{{ parkrec.plateno }}</span>
              <div class="check-pic" @click="showImg">查看照片</div>
            </div>
            <div class="in-time">
              <span>{{ parkrec.inTime || "" }}入场</span>
            </div>
            <div class="discount-panel">
              <div class="div_check" @click="isChecked" v-show="checkedCouponOptions.length > 0 && !parkrec.couponid">
                <div class="div_left" :class="{ check: checked }">
                  <img src="../../common/img/check.png" alt />
                </div>
                <p class="div_right">是否使用优惠券</p>
              </div>
              <article class="weui-article" v-if="checkedCouponOptions.length > 0 && checked">
                <section>
                  <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                    <div class="weui-cell__hd">
                      <label class="weui-label">优惠券</label>
                    </div>
                    <div class="weui-cell__bd" style="color: #6d6d6d" v-if="checkedCouponOptions.length <= 0">
                      无
                    </div>
                    <div class="weui-cell__bd" v-else @click="handleCouponOption">
                      {{ checkedCoupon }}
                    </div>
                  </div>
                </section>
              </article>
            </div>
          </div>
          <div class="order-info">
            <div class="price-wrap">
              {{
                parkrec.finalMoney != null && parkrec.finalMoney >= 0 ? "已" : "需"
              }}缴费
              <div class="price">¥{{ money || "0.00" }}</div>
            </div>
            <div class="order-item" v-show="checked">
              优惠
              <div class="right-order">¥{{ couponFee || "0.00" }}</div>
            </div>
            <div class="order-item">
              入场时间
              <div class="right-order">{{ parkrec.inTime || "未获取到" }}</div>
            </div>
            <div class="order-item">
              出场时间
              <div class="right-order">{{ parkrec.outTime || "无" }}</div>
            </div>
            <div class="order-item">
              停车时长
              <div class="right-order">{{ parkrec.parkHours || "0分钟" }}</div>
            </div>
          </div>
        </div>

        <div class="btn-pay" @click="pay">
          {{
            parkrec.status == 1 && parkrec.finalMoney != null && parkrec.finalMoney >= 0
              ? "已支付"
              : "去支付"
          }}
        </div>




        <div class="btn-pay" @click="payment" v-if="(parkrec.parkinglotId == 36 || parkrec.parkinglotId == 13) &&
          this.parkingInfo.bankName == '苏州银行'
        ">
          {{
            parkrec.status == 1 && parkrec.finalMoney != null && parkrec.finalMoney >= 0
              ? "已支付"
              : "数字货币支付"
          }}
        </div>
        <div v-if="this.parkingInfo.bankName == '交通银行' ||
          this.parkingInfo.bankName == '交通银行条码'
        " class="btn-pay" @click="walletPay">
          {{
            parkrec.status == 1 && parkrec.finalMoney != null && parkrec.finalMoney >= 0
              ? "已支付"
              : "数字钱包"
          }}
        </div>

        <div v-if="isCardPay == 1" class="btn-pay btn-member" @click="memberPay">
          会员卡支付
        </div>

        <div class="hint-wrapper">
          <div class="hint-panel">
            <div class="hint-item">温馨提示 :</div>
            <div class="hint-item">1. 关注公众号，停车费支付更便捷</div>
            <div class="hint-bottom">
              <img src="../../common/img/bend_arrow.png" />
              <div>
                点击箭头指向的
                <span @click="allow" style="color: #2e8ded">蓝色小字</span>关注我们
              </div>
              <div class="btn-allow" @click="allow">畅停天下</div>
            </div>
          </div>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>

<script>
import { getParkingPaymentInfo } from "api/coupon/area";
import { mapGetters, mapMutations } from "vuex";
import {
  getAvailableCouponList,
  userUseCoupon,
} from "../../api/coupon/personalParkingFee";
import { getCode, getOpenId, getBuyId, HttpGetCode } from "../../api/coupon/auth";
import { getRecordByPlateNo } from "../../api/coupon/platePay";
import base from "@/api/base";
import { redirectToWeChatAuth } from "@/utils/redirect"

export default {
  data() {
    return {
      isSzBank: false,
      userBuyId: null,
      money: undefined,
      paymentType: 0,
      // 进出记录
      record: "",
      // imgs: [fail],
      baseUrl: base.url + "/",
      baseHttps: base.https,
      baseHttp: base.http,
      checked: true,
      canLaunchMiniProgram: false,
      checkedCoupon: undefined,
      checkedCouponId: undefined || null || "",
      checkedCouponOptions: [],
      openId: undefined,
      keyTopOrderNo: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "orderInfo",
      "parkinglotId",
      "parkrec",
      "parkingInfo",
      "areaId",
      "orderSnList",
      "couponFee",
      "interfaceManner",
      "isCardPay",
      "keyTopInImgUrl",
      "abParkId",

      "resultOrderSn",
    ]),
  },
  created() {
    if (this.parkrec.unpaidMoney > 0) {
      console.log(this.parkrec.parkinglotId, "parkrec");
      this.money = parseFloat(this.parkrec.unpaidMoney).toFixed(2);
    } else if (this.parkrec.finalMoney != null && this.parkrec.finalMoney >= 0) {
      this.money = parseFloat(this.parkrec.finalMoney).toFixed(2);
    } else {
      this.money = parseFloat(this.orderInfo.totalPrice).toFixed(2);
    }
    if (this.parkrec.parkinglotId != 49) {//场内码人才市场不走优惠券
      if (!this.parkrec.parkCoupon) {
        this.getUserCouponList();
      }
    }




    this.$getAdInfo(this.abParkId);
  },
  mounted() {


    // this.$api.parkinglot.getParkinglotInfo(this.parkrec.parkinglotId).then(res => {
    //     if (res.data.code == 200 && res.data.data) {
    //         this.setParkingInfo(res.data.data);
    // this.$api.area.getBasicConfig(this.areaId).then(req => {
    // if (req.data.code == 200) {
    console.log(this.parkingInfo, "this.parkingInfo");
    console.log(this.$route.params, '45645646');

    if (this.parkingInfo.bankName == "苏州银行" || this.parkingInfo.bankId == "5" || this.parkingInfo.bankId == "16" || this.parkingInfo.bankName == "易生支付" || this.parkingInfo.bankId == "23") {
      //所选银行为苏州银行(后期改为判断这个银行是否需要授权)
      let openIdForOrder = localStorage.getItem("userOpenId");
      let userBuyId = localStorage.getItem("userBuyId");
      console.log(this.$route, '路由参数');
      //如果本地没有openId,则让它授权
      if (this.$route.params.isEntry) {
        //利用params刷新就消失的特性 isEntry为一个标记作用
        if (this.checkBrowser.id == 13) {
          //如果是微信环境就进行微信授权
          if (!openIdForOrder) {
            this.getCode("wx");
          } else {
            this.isSzBank = true
            this.openId = openIdForOrder;

          }
        } else {
          if (!userBuyId) {
            this.getCode("wx");
          } else {
            this.isSzBank = false
            this.userBuyId = userBuyId;
          }
        }
      } else {
        if (this.checkBrowser.id == 13) {
          console.log(this.$route.query, '$route.query');
          getOpenId(this.$route.query.code).then((res) => {
            if (res.code == 200) {
              //&& res.msg != 'null'
              console.log("接口获取的openid", res);
              this.isSzBank = true
              localStorage.setItem("userOpenId", res.msg);
              this.openId = res.msg;
            } else {
              alert("未获得授权");
            }
          });
        } else {
          getBuyId(this.$route.query.auth_code).then((res) => {
            localStorage.setItem("userBuyId", res.msg);
            this.userBuyId = res.msg
          });
        }

      }


      // if (this.$route.query.code) {

      // } else {
      //   this.openId = openIdForOrder;
      // }
    }
    // }
    // })
    // }
    // });
  },
  methods: {

    ...mapMutations({
      setCouponFee: "SET_COUPONFEE",
      setParkingInfo: "SET_PARKING_INFO",
      setParkrec: "SET_PARKREC",
      setParkingId: "SET_PARKINGLOTID",
      setOrderInfo: "SET_ORDER_INFO",
      setOrderSnList: "SET_ORDERSNLIST",
      setOrderSn: "SET_ORDERSN",

    }),
    /**获取授权地址*/
    getCode(flag) {
      redirectToWeChatAuth("/insideOrder")
    },
    /*选择优惠券**/
    handleCouponOption() {
      if (
        this.parkrec.couponid ||
        (this.parkrec.finalMoney != null && this.parkrec.finalMoney >= 0)
      )
        return; //如果此订单已使用过优惠券或已支付就不让picker弹出
      this.$weui.picker(this.checkedCouponOptions, {
        onChange: (result) => {
          this.checkedCoupon = result[0].coupontypeName;
          this.checkedCouponId = result[0].couponId;
        },
        onConfirm: (result) => {
          this.checkedCoupon = result[0].coupontypeName;
          this.checkedCouponId = result[0].couponId;
        },
        onClose: () => {
          this.userChooseCoupon();
        },
        title: "可选优惠券",
      });
    },
    /**获取用户的优惠券列表*/
    getUserCouponList() {
      if (this.parkrec.finalMoney != null && this.parkrec.finalMoney >= 0) {
        //已支付
        if (this.parkrec.couponid) {
          //已使用过优惠券 仅展示
          this.checkedCouponOptions = [
            { label: this.parkrec.couponName || "抵扣优惠券" },
          ];
          this.checkedCoupon = this.parkrec.couponName || "抵扣优惠券";
          this.checkedCouponId = this.parkrec.couponid;
        }
      } else {
        if (this.parkrec.couponid) {
          //正在出场 公众号推送面板进入 仅展示出场时自动分配的优惠券
          this.checkedCouponOptions = [
            { label: this.parkrec.couponName || "抵扣优惠券" },
          ];
          this.checkedCoupon = this.parkrec.couponName || "抵扣优惠券";
          this.checkedCouponId = this.parkrec.couponid;
        } else {
          let form = {
            parkinglotId: this.parkinglotId,
            inTime: this.parkrec.inTime,
            outTime: this.parkrec.outTime,
            platenumber: this.parkrec.plateno,
          };
          getAvailableCouponList(form).then((res) => {
            if (res.code === 200) {
              let checkedCouponOptions = res.data;
              if (checkedCouponOptions.length > 0) {
                checkedCouponOptions.map((item) => {
                  item.label = item.coupontypeName;
                });
                this.checkedCoupon = checkedCouponOptions[0].coupontypeName;
                this.checkedCouponId = checkedCouponOptions[0].couponId;
                this.userChooseCoupon();
              } else {
                this.checked = false;
                // this.parkrec.unpaidMoney = parseFloat(this.orderInfo.totalPrice).toFixed(2);
                this.setCouponFee(0.0);
              }
              this.checkedCouponOptions = checkedCouponOptions;
            }
          });
        }
      }
    },
    userChooseCoupon(type) {
      console.log(this.parkrec, "选择优惠券");
      let form = {
        plateNo: this.parkrec.plateno,
        parkinglotId: this.parkinglotId,
        areaId: this.parkrec.areaId,
        inTime: this.parkrec.inTime,

        couponIds: this.checkedCouponId ? [this.checkedCouponId] : [],
        // allMoney: parseFloat(this.parkrec.allmoney).toFixed(2)
        allMoney: parseFloat(this.parkrec.unpaidMoney).toFixed(2),
      };

      userUseCoupon(form).then((res) => {
        if (res.code === 200) {
          if (type) {
            this.money = parseFloat(res.data.unpaidMoney).toFixed(2);

            this.setCouponFee(parseFloat(res.data.parkCoupon || 0).toFixed(2));
            if (parseFloat(res.data.unpaidMoney) <= 0) {
              this.noMoneyToPay();
            } else {

              this.$api.order
                .order({
                  totalPrice: this.money,
                  parkRec: this.parkrec.id,
                  parkinglotId: this.parkinglotId,
                  goodsType: 3,
                  closed: 0,
                  paymentPlatform: this.checkBrowser.id,
                  areaId: this.parkrec.areaId,
                  paymentPlatformsn: this.keyTopOrderNo,
                })
                .then((res) => {
                  // console.log(res.data);
                  console.log(res, "获取订单");
                  if (res.data.code == 200) {
                    this.orderSnList[this.checkedCouponId] = res.data.data.orderSn;
                    this.isShowHint = false;
                    this.setOrderSnList(this.orderSnList);
                    // this.toPay();
                  } else {
                    this.isShowHint = false;
                    this.showAlert(res.data.msg);
                  }
                });

              this.showAlert("支付金额已变更");
            }
          } else {
            if (res.msg == "优惠券使用失败..") {
              this.checkedCouponId = undefined;
              this.checked = false;
              this.money = parseFloat(res.data.unpaidMoney).toFixed(2);
              this.setCouponFee(0.0);
              this.showAlert("该优惠券不可用，请重新选择");
            } else {
              this.money = parseFloat(res.data.unpaidMoney).toFixed(2);
              this.setCouponFee(parseFloat(res.data.parkCoupon || 0).toFixed(2));
            }
          }
        } else {
          this.checkedCouponId = undefined;
          this.checked = false;
          this.money = parseFloat(this.parkrec.unpaidMoney).toFixed(2);
          this.setCouponFee(0.0);
          this.showAlert("该优惠券不可用，请重新选择");
        }
      });
    },
    isChecked() {
      this.checked = !this.checked;
      if (!this.checked) {
        this.checkedCouponId = undefined;
        console.log(this.parkrec, "this.parkrec");
        this.money = parseFloat(this.parkrec.unpaidMoney).toFixed(2);
        this.setCouponFee(0.0);
      } else {
        this.getUserCouponList();
      }
    },
    showImg() {
      this.$createImagePreview({
        imgs:
          this.interfaceManner == 2
            ? this.keyTopInImgUrl
            : [this.baseUrl + this.parkrec.inImgUrl],
      }).show();
    },
    pay() {
      if (this.parkrec.finalMoney != null && this.parkrec.finalMoney >= 0) {
        this.$createToast({
          type: "warn",
          time: 1000,
          txt: "已支付",
        }).show();
        return;
      }
      // "resultOrderSn",
      // console.log(this.orderInfo.orderSn ,'this.orderInfo.orderSn');
      // if ( "DD7875700999783456" ==this.resultOrderSn ) {
      if (this.orderInfo.orderSn == this.resultOrderSn) {
        this.$createToast({
          type: "warn",
          time: 4000,
          txt: "该订单已支付",
        }).show();
        return;
      }
      this.transferNewPay();
    },
    walletPay() {
      if (this.parkrec.finalMoney != null && this.parkrec.finalMoney >= 0) {
        this.$createToast({
          type: "warn",
          time: 1000,
          txt: "已支付",
        }).show();
        return;
      }
      this.transferWalletPay();
    },
    /**新模式
     * params:{
     *     isCoupon:是否使用优惠券
     * }*/
    transferNewPay() {
      if (parseFloat(this.money) <= 0) {
        this.$api.parkinglot
          .noPay({
            orderSn: this.orderInfo.orderSn,
            // allmoney:this.parkrec.allmoney
            parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
            couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
            isCoupon: this.checkedCouponId ? 1 : 0,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$createToast({
                type: "warn",
                time: 1000,
                txt: "优惠券扣除成功",
              }).show();
              this.$router.push("PayResult");
            } else {
              this.showAlert(res.data.msg);
            }
          });
      } else if (!this.orderSnList[this.checkedCouponId] && this.checkedCouponId) {
        this.$api.order.order({
            totalPrice: parseFloat(this.money).toFixed(2),
            parkRec: this.parkrec.id,
            parkinglotId: this.parkinglotId,
            goodsType: 3,
            closed: 0,
            paymentPlatform: this.checkBrowser.id,
            areaId: this.parkrec.areaId,
            paymentPlatformsn: this.keyTopOrderNo,
          })
          .then((res) => {
            // console.log(res.data);
            console.log(res, "获取订单");
            if (res.data.code == 200) {
              this.orderSnList[this.checkedCouponId] = res.data.data.orderSn;

              this.setOrderSnList(this.orderSnList);
              this.toPay();
            } else {
              this.showAlert(res.data.msg);
            }
          });
      } else {
        console.log("222222222222");
        this.toPay();
      }
      // }
    },
    transferWalletPay() {
      if (!this.orderSnList[this.checkedCouponId] && this.checkedCouponId) {
        this.$api.order
          .order({
            totalPrice: parseFloat(this.money).toFixed(2),
            parkRec: this.parkrec.id,
            parkinglotId: this.parkinglotId,
            goodsType: 3,
            closed: 0,
            paymentPlatform: this.checkBrowser.id,
            areaId: this.parkrec.areaId,
            paymentPlatformsn: this.keyTopOrderNo,
          })
          .then((res) => {
            console.log(res.data, "获取");
            if (res.data.code == 200) {
              this.orderSnList[this.checkedCouponId] = res.data.data.orderSn;
              console.log(res.data.data, "res.data.data");
              this.setOrderSnList(this.orderSnList);
              this.toWalletPay();
            } else {
              this.showAlert(res.data.msg);
            }
          });
      } else {
        this.toWalletPay();
      }
      // }
    },
    getParkingPaymentInfo() {
      let data = {
        parkinglotId: this.parkinglotId,
        ts: new Date().getTime(),
        plateNo: this.parkrec.plateno,
      };
      getParkingPaymentInfo(data).then((res) => {
        this.keyTopOrderNo = res.data.keyTopOrderNo;
        this.parkFeeToast(res);
      });
    },
    parkFeeToast(req) {
      console.log(req, "支付前");
      if (req.code === 200) {
        //使用场内码提前支付时用户扫码后不支付 页面一直放在那 很可能导致当前金额大于当时扫码查询的金额
        if (parseFloat(req.data.unpaidMoney) > parseFloat(this.parkrec.unpaidMoney)) {
          console.log("req1111111");
          console.log("order1");

          this.$api.order.order({
              totalPrice: parseFloat(req.data.unpaidMoney).toFixed(2),
              parkRec: req.data.id,
              parkinglotId: this.parkinglotId,
              goodsType: 3,
              closed: 0,
              paymentPlatform: this.checkBrowser.id,
              areaId: req.data.areaId,
              paymentPlatformsn: this.keyTopOrderNo,
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.setOrderInfo(res.data.data);
                console.log(req.data.data, "req.data.data");
                this.money = parseFloat(req.data.unpaidMoney).toFixed(2);

                if (this.checkedCouponId) {
                  this.userChooseCoupon("pay");
                } else {
                  console.log("order2");
                  this.$api.order.order({
                      totalPrice: this.money,
                      parkRec: this.parkrec.id,
                      parkinglotId: this.parkinglotId,
                      goodsType: 3,
                      closed: 0,
                      paymentPlatform: this.checkBrowser.id,
                      areaId: req.data.areaId,
                      paymentPlatformsn: this.keyTopOrderNo,
                    })
                    .then((res) => {
                      // console.log(res.data);
                      console.log(res, "获取订单");
                      if (res.data.code == 200) {
                        this.orderSnList[this.checkedCouponId] = res.data.data.orderSn;

                        this.setOrderSnList(this.orderSnList);
                        // this.toPay();
                      } else {
                        this.showAlert(res.data.msg);
                      }
                    });
                  this.showAlert("支付金额已变更");
                }
              }
            });
        } else if (
          parseFloat(req.data.unpaidMoney) == parseFloat(this.parkrec.unpaidMoney) &&
          req.data.parkHours != this.parkrec.parkHours
        ) {
          //金额没变但是停车时长变了
          this.confirmToPay();
          console.log("req2222222");
        } else {
          console.log("req3333333");
          this.confirmToPay();
        }
        this.setParkrec(req.data);
      }
    },
    parkFeeWallet(req) {
      if (req.code === 200) {
        //使用场内码提前支付时用户扫码后不支付 页面一直放在那 很可能导致当前金额大于当时扫码查询的金额
        if (parseFloat(req.data.unpaidMoney) > parseFloat(this.parkrec.unpaidMoney)) {
          this.$api.order
            .order({
              totalPrice: parseFloat(req.data.unpaidMoney).toFixed(2),
              parkRec: req.data.id,
              parkinglotId: this.parkinglotId,
              goodsType: 3,
              closed: 0,
              paymentPlatform: this.checkBrowser.id,
              // areaId: this.areaId,
              areaId: req.data.areaId,
              paymentPlatformsn: this.keyTopOrderNo,
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.setOrderInfo(res.data.data);
                this.money = parseFloat(req.data.unpaidMoney).toFixed(2);
                if (this.checkedCouponId) {
                  this.userChooseCoupon("pay");
                } else {
                  console.log("钱包支付");
                  this.showAlert("支付金额已变更");
                }
              }
            });
        } else if (
          parseFloat(req.data.unpaidMoney) == parseFloat(this.parkrec.unpaidMoney) &&
          req.data.parkHours != this.parkrec.parkHours
        ) {
          //金额没变但是停车时长变了
          this.confirmToWalletPay();
        } else {
          this.confirmToWalletPay();
        }
        this.setParkrec(req.data);
      }
    },
    payment() {
      this.paymentType = 1;
      if (this.orderInfo.orderSn == this.resultOrderSn) {
        this.$createToast({
          type: "warn",
          time: 4000,
          txt: "该订单已支付",
        }).show();
        return;
      }
      this.pay();
    },
    toPay() {
      console.log(this.interfaceManner, "this.interfaceManner");
      if (this.interfaceManner == 2) {
        this.getParkingPaymentInfo();
      } else {
        console.log("parkFeeToast");
        getRecordByPlateNo({
          plateno: this.parkrec.plateno,
          parkinglotId: this.parkinglotId,
        }).then((req) => {
          this.parkFeeToast(req);
        });
      }
    },
    toWalletPay() {
      if (this.interfaceManner == 2) {
        this.getParkingPaymentInfo();
      } else {
        getRecordByPlateNo({
          plateno: this.parkrec.plateno,
          parkinglotId: this.parkinglotId,
        }).then((req) => {
          this.parkFeeWallet(req);
        });
      }
    },
    launchMiniProgram() {
      wx.navigateToMiniProgram({
        appId: 'wx44cf62a26ce78506',
        path: 'pages/car/carPay?payParam=' + encodeURIComponent(payParam),
        envVersion: 'trial', // 可设为 develop（开发版），trial（体验版），release（正式版）
        success(res) {
          // 启动成功
          console.log('Launch success');
        },
        fail(err) {
          // 启动失败
          console.log('Launch failed', err);
        }
      });
    },
    confirmToPay() {
      if (parseFloat(this.money) <= 0) {
        this.noMoneyToPay();
      } else {
        console.log(localStorage.getItem("userOpenId"), '支付时的openId');
        let form = {
          orderSn: this.orderSnList[this.checkedCouponId] || this.orderInfo.orderSn,
          parkinglotId: this.parkinglotId,
          totalAmount: parseFloat(this.money).toFixed(2),
          isCoupon: this.checkedCouponId ? 1 : 0,
          couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
          payType: this.checkBrowser.id || 13,
          parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
          openId: this.isSzBank ? localStorage.getItem("userOpenId") : localStorage.getItem("userBuyId"),
        };
        // pay/unionOrder

        if (this.paymentType == 0) {
          // if (this.parkinglotId == '252') {
          //   let params = {
          //     orderSn: this.orderSnList[this.checkedCouponId] || this.orderInfo.orderSn,
          //     parkinglotId: this.parkinglotId,
          //     totalAmount: parseFloat(this.money).toFixed(2),
          //     isCoupon: this.checkedCouponId ? 1 : 0,
          //     couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
          //     payType: this.checkBrowser.id || 13,
          //     parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
          //     openId: this.isSzBank ? localStorage.getItem("xcxopenId") : localStorage.getItem("xcxopenId"),
          //     appId: localStorage.getItem("xcxappId")
          //   };
          //   this.$api.order.yddPay(params).then((res) => {
          //     if (res.data.code == 200) {
          //       this.yddShowAlert();
          //     } else if (res.data.code != 200) {
          //       this.showAlert(res.data.msg);
          //     } else if (res.data.data.errcode == 0) {
          //       this.showAlert(res.data.msg);
          //     } else {
          //       this.showAlert(res.data.data.returnMessage);
          //     }
          //   });
          // } else {
          //   this.$api.order.pay(form).then((res) => {
          //     if (res.data.code == 200) {
          //       this.$pay(res.data);
          //     } else if (res.data.code != 200) {
          //       this.showAlert(res.data.msg);
          //     } else if (res.data.data.errcode == 0) {
          //       this.showAlert(res.data.msg);
          //     } else {
          //       this.showAlert(res.data.data.returnMessage);
          //     }
          //   });
          // }

          this.$api.order.pay(form).then((res) => {
            if (res.data.code == 200) {
              this.$pay(res.data);
            } else if (res.data.code != 200) {
              this.showAlert(res.data.msg);
            } else if (res.data.data.errcode == 0) {
              this.showAlert(res.data.msg);
            } else {
              this.showAlert(res.data.data.returnMessage);
            }
          });

        } else {
          this.$api.order.szbWalletPay(form).then((res) => {


            if (res.data.code == 200) {
              this.$pay(res.data.data);
            } else {
              console.log(res.data.data.returnMessage, "res.data.data.returnMessage");

              this.showAlert(res.data.data.returnMessage);
            }
          });
        }
      }
    },
    confirmToWalletPay() {
      if (parseFloat(this.money) <= 0) {
        this.noMoneyToPay();
      } else {
        let form = {
          orderSn: this.orderSnList[this.checkedCouponId] || this.orderInfo.orderSn,
          parkinglotId: this.parkinglotId,
          totalAmount: parseFloat(this.money).toFixed(2),
          isCoupon: this.checkedCouponId ? 1 : 0,
          couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
          payType: this.checkBrowser.id || 13,
          parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
          openId: this.isSzBank ? (localStorage.getItem("userOpenId") || this.openId) : (localStorage.getItem("userBuyId") || this.userBuyId),
        };
        this.$api.order.walletPay(form).then((res) => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.$pay(res.data);
          }
        });
      }
    },
    noMoneyToPay() {
      this.$api.parkinglot
        .noPay({
          orderSn: this.orderInfo.orderSn,
          parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
          couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
          isCoupon: this.checkedCouponId ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$createToast({
              type: "warn",
              time: 1000,
              txt: "优惠券扣除成功",
            }).show();
            this.$router.push("PayResult");
          } else {
            this.showAlert(res.data.msg);
          }
        });
    },
    showAlert(value) {
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: this.plateName,
        content: value,
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
      }).show();
    },
    yddShowAlert(value) {
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: this.plateName,
        content: '返回小程序支付',
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
        onConfirm: () => {  // 处理确认按钮点击事件
          this.launchMiniProgram()
        },
      }).show();
    },
    // 获取10位时间戳
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    back() {
      this.$router.go(-1);
    },
    // 关注公众号
    allow() {
      window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU1MjE3NTEzNw==&scene=124#wechat_redirect";
    },
    memberPay() {
      if (this.orderInfo.orderSn == this.resultOrderSn) {
        this.$createToast({
          type: "warn",
          time: 4000,
          txt: "该订单已支付",
        }).show();
        return;
      }
      this.$router.push({
        name: "memberOrder",
        params: {
          parkinglotId: this.parkinglotId,
          plateNo: this.parkrec.plateno,
          playMoney: parseFloat(this.parkrec.allmoney).toFixed(2),
        },
      });
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import '~common/stylus/variable';
@import '~common/stylus/mixin';

.wrapper {
	position: relative;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	overflow: hidden;
	.cube-scroll {
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 100%
		/*overflow hidden*/
		/*background: #ffffff;*/
		margin-bottom 50px
		.advwrap {
			/*width 100%*/
			/*height 0*/
			/*padding-bottom 40%*/
		}
		.weui-article {
			padding 0
			margin 0
			p {
				font-size $article-merchant-p
				color $article-p-color
				line-height 20px
			}
			.weui-cell_select-after {
				padding-left 0
			}
		}
		.weui-article .weui-label {
			width 80px
		}
		.weui-article .weui-cell__bd {
			line-height 40px
			font-size 15px
		}
		.weui-article section {
			margin-bottom 0 !important
		}
		.header {
			width: 100%;
			height: 45px;
			display: flex;
			flex-direction: row;
			align-items: center;
			background: #ffffff;
			position: relative;
			justify-content: center;
			border-bottom: 1px solid #f5f5f5;

			i {
				position: absolute;
				left: 10px;
				font-size: 18px;
				padding: 6px;
			}
		}

		.inner-wrapper {
			width: 100%;
			height: 750px;
			background: #FFFFFF;
			display: flex;
			flex-direction: column;
			align-items: center;

			.order-panel {
				width: 90%;
				display: flex;
				flex-direction: column;
				background: #ffffff;
				border-radius: 5px;
				padding-left: 16px;
				padding-right: 16px;
				box-sizing: border-box;
				margin-top: 28px;

				.order-record {
					display: flex;
					flex-direction: column;
					align-items: center;

					.park-name {
						font-size: 22px;
						font-weight: 500;
					}

					.plate {
						display: flex;
						align-items: center;
						font-size: 30px;

						color: #0c35ff;

						.check-pic {
							font-size: 14px;
							color: #A1A8AA;
							padding: 5px 15px;
							border: 1px solid rgba(161, 168, 170, 0.6);
							margin-left: 10px;
						}
					}

					.in-time {
						font-size: 15px;
						color: #666;
					}
				}
				.discount-panel {
					width: 100%;
					display: flex;
					flex-direction: column;
					padding 20px 0 10px 0;
					border-bottom 1px solid #f5f5f5
					.discount-wrap {
						font-size: 15px;
						color: #666;
						width: 100%;
						display: flex;
						justify-content: space-between;
						padding: 30px 0 10px 0;

						span:last-child {
							color: #B1B7BE;
						}
					}

					.div_check {
						width: 100%;
						height: 35px;
						display: flex;
						flex-direction: row;
						align-items: center;
						font-size: 15px;

						.div_left {
							height: 16px;
							width: 16px;
							border: 1px solid #dddddd;
							margin-right: 8px;

							img {
								width: 100%;
								height: 100%;
								display: none;
							}
						}

						.check {
							border: 0px;

							img {
								display: block;
							}
						}

						.div_right {
							font-size: 16px;
						}
					}
				}

				.order-info {
					width: 100%;
					padding-top 10px;
					display: flex;
					flex-direction: column;
					box-sizing: border-box;

					.price-wrap {
						color #0d0d0d
						display: flex;
						font-size: 20px;
						font-weight: 500;
						padding: 10px 0;

						.price {
							font-size: 18px;
							font-weight: 600;
							color: #EB3120;
							padding-left: 10px;
						}
					}

					.order-item {
						width: 100%;
						height: 30px;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
						font-size: 14px;
						color: #B0B0B0;
					}
				}
			}

			.btn-pay {
				width: 90%;
				height: 45px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				color: #ffffff;
				background: #5495f6;
				border-radius: 5px;
				margin-top: 20px;
			}
			.btn-member {
				background-color $color-estate
			}

			.hint-wrapper {
				width: 100%;
				height: 170px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.hint-panel {
					width: 90%;
					height: 170px;
					display: flex;
					flex-direction: column;
					margin-top: 10px;
					position: relative;
				}

				.hint-item {
					width: 100%;
					height: 30px;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					font-size: 14px;
					color: #999999;
				}

				.hint-bottom {
					position: absolute;
					right: 70px;
					bottom: 0;
					display: flex;
					flex-direction: row;
					align-items: baseline;
					font-size: 14px;

					img {
						width: 80px;
						position: absolute;
						right: -48px;
						top: -30px;
					}

					.btn-allow {
						color: #2e8ded;
						position: absolute;
						bottom: -55px;
						right: -85px;
						font-size: 17px;
						padding: 12px;
						letter-spacing: 2px;
					}
				}
			}
		}
	}
}
</style>
